import { ToastProps } from "@/components/toasts/StyledToast";
import { atom, useAtom, useSetAtom } from "jotai";
import { useEffect } from "react";

const nofiticationAtom = atom<ToastProps | false>(false);
nofiticationAtom.debugLabel = "notification atom";
export function useNotificationStore() {
    const [notification, setNotification] = useAtom(nofiticationAtom);

    //clear out the notification after it's been on screen for the duration
    useEffect(() => {
        if (notification) {
            const timer = setTimeout(
                () => setNotification(false),
                (notification.autoClose ?? 3000) + 1000,
            );
            // Clear on change/unmount so a stale timer from a previous
            // notification can't fire and wipe a newer one.
            return () => clearTimeout(timer);
        }
    }, [notification]);

    return {
        notification,
        setNotification,
    };
}

/**
 * Write-only access to the notification — does NOT subscribe to the value, so
 * components that only need to *fire* a toast (and don't render it) won't
 * re-render on every notification change.
 */
export function useSetNotification() {
    return useSetAtom(nofiticationAtom);
}
